import { queryOptions } from '@tanstack/react-query';

import { toConversationError } from './errors';
import type { SharedSurvey } from './sharedSurvey';

import { ONE_MINUTE } from '@/constants/time';
import { fetchClient } from '@/util/fetchClient';

/** A published survey as the share picker lists it, with the status the share rule reads. */
export type ShareableSurvey = SharedSurvey & { status: string };

export const shareableSurveyKeys = {
  all: ['shareableSurveys'] as const,
};

async function getPublishedSurveys(): Promise<ShareableSurvey[]> {
  try {
    const { data } = await fetchClient.GET('/v2/surveys');

    return (data?.data ?? [])
      .map((survey) => ({
        surveyGroupId: survey.surveyGroupId,
        slug: survey.slug ?? null,
        name: survey.name,
        type: survey.type,
        status: survey.status,
      }))
      .sort((left, right) => left.name.localeCompare(right.name));
  } catch (error) {
    throw toConversationError(error);
  }
}

/**
 * Every published survey, by name, for staff to share into a member's support
 * thread. Published is what a member can open. Each keeps only what its card
 * needs, not the schema the list carries.
 */
export function getShareableSurveysQueryOptions() {
  return queryOptions({
    queryKey: shareableSurveyKeys.all,
    queryFn: getPublishedSurveys,
    staleTime: ONE_MINUTE,
  });
}
